import { action, makeAutoObservable } from "mobx"
import { ProgStatus } from "../models/utilTypes"
import ApiService from "../services/ApiService"
import Cookies from 'js-cookie'
import { rootStore } from "../StApp"
import AppCrypto, { CryptoService } from "../services/CryptoService"
import MqttService from "../services/MqttService"
import LocalStorageService from "../services/LocalStorageService"
import { GoogleLoginResponse, GoogleLoginResponseOffline } from "react-google-login"
import { FedLoginRequest } from "../models/api/FedLoginRequest"
import { AxiosResponse } from "axios"
import { LoginResponse } from "../types/LoginResponse"

export default class LogInStore {

    userName: string = ''
    password: string = ''
    logInProgress: ProgStatus = 'INIT'
    api = ApiService

    constructor() {

        makeAutoObservable(this, { api: false })
    }

    @action
    setUserName(data: string) {
        this.userName = data
    }

    @action
    setPassword(data: string) {
        this.password = data
    }

    @action
    logInUser() {

        this.logInProgress = 'LOADING'
        //AppCrypto.generateKeys()
        this.api.loginUser({ userId: this.userName, password: this.password })
            .then(result => {
                this.handleLoginResp(result)
            })
            .catch(err => {
                this.logInProgress = 'FAILED'
                AppCrypto.dumpKeys()
                console.error(err)
            })

    }

    handleGoogleAuthresponse(resp: GoogleLoginResponse) {

        const fedLoginReq: FedLoginRequest = {
            email: resp.profileObj.email,
            token: resp.tokenId
        }

        this.api.fedLogin(fedLoginReq)
            .then(resp =>{
                this.handleLoginResp(resp)
            })
            .catch(err => {
                this.logInProgress = 'FAILED'
                AppCrypto.dumpKeys()
                console.error(err)
            })
    }

    private handleLoginResp(result: AxiosResponse<LoginResponse>) {

        console.log(result.data)
        rootStore.mainStore.setToken(result.data.token)
        rootStore.mainStore.setUserName(result.data.data.userId)
        rootStore.mainStore.setUid(result.data.data.uid)
        Cookies.set('token', result.data.token, { expires: 365 })
        Cookies.set('userName', result.data.data.userId, { expires: 365 })
        Cookies.set('uid', result.data.data.uid, { expires: 365 })
        Cookies.set('privateKey', result.data.data.privKey, { expires: 365 })
        LocalStorageService.updateStorage('likes_left', result.data.data.likes_left)
        rootStore.mainStore.updateNameOfUser(result.data.data.name)
        this.logInProgress = 'SUCCESS'
        AppCrypto.initKeys()
        MqttService.connect()

    }
}